export function reportList(state = [], action) {
    switch (action.type) {
        case 'REPORT_LIST':
        console.log(action.data);
        // action.list="yes";
            return action.data
        default:
            return state
    }
}